<template>
  <div>
    <!--
    <v-progress-circular
      v-show="loading"
      :value="percValue"
      size="40"
      width="3"
      rotate="270"
      color="dover-blue accent-4"
    >{{ percValue }}</v-progress-circular>
    -->
    <v-progress-linear
      :active="loading"
      :indeterminate="indeterminate"
      :value="percValue"
      buffer-value="100"
      background-opacity="0.1"
      height="8"
      color="dover-blue accent-4"
      striped
      rounded
      top />
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: () => []
    },
    indeterminate: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      type: Number,
      required: false,
      default: 1
    },
    maxValue: {
      type: Number,
      required: false,
      default: 100
    }
  },
  computed: {
    percValue () {
      return this.Maglink.RoundFormat((this.value * 100) / this.maxValue, 0)
    }
  },
  methods: { }
}
</script>
